<div id="app_comp">
  <div id="nav-container">
    <app-nav-component></app-nav-component>
  </div>
  <div class="router-div">
    <router-outlet> </router-outlet>
  </div>
</div>
